export default __webpack_public_path__ + "1484c0a1a3d578c19c04b6f001d495da.png";